import { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Stack,
  Typography,
  Box,
  TextField,
  Alert,
  Chip,
  Divider,
} from "@mui/material";
import VerifiedIcon from "@mui/icons-material/Verified";
// import ContentCopyIcon from "@mui/icons-material/ContentCopy"; // 购买联系方式已移除
import { post_redeem } from "../../client/paipan";

const PLANS = [
  {
    key: "month",
    label: "月会员",
    price: "19",
    unit: "元/月",
    desc: "适合短期使用",
  },
  {
    key: "year",
    label: "年会员",
    price: "99",
    unit: "元/年",
    desc: "立省 129 元",
    highlight: true,
  },
  {
    key: "lifetime",
    label: "永久会员",
    price: "199",
    unit: "元永久",
    desc: "一次购买，终身使用",
  },
];

export default function MemberDialog({ open, onClose, user, onRedeemSuccess }) {
  const [code, setCode] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [loading, setLoading] = useState(false);

  const handleClose = () => {
    setCode("");
    setError("");
    setSuccess("");
    onClose();
  };

  const handleRedeem = async () => {
    if (!code.trim()) {
      setError("请输入激活码");
      return;
    }
    setError("");
    setSuccess("");
    setLoading(true);

    const res = await post_redeem(code.trim());
    if (res && res.token) {
      localStorage.setItem("token", res.token);
      setSuccess("兑换成功！会员已开通");
      onRedeemSuccess?.({
        ...user,
        member_type: 1,
        member_expires_at: res.member_expires_at,
        is_member: true,
      });
      setCode("");
    } else {
      setError(res?.message || "兑换失败，请检查激活码");
    }
    setLoading(false);
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="xs" fullWidth>
      <DialogTitle sx={{ textAlign: "center", pb: 1 }}>
        <VerifiedIcon color="primary" sx={{ fontSize: 40, mb: 1, display: "block", mx: "auto" }} />
        <Typography variant="h6">开通会员</Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
          解锁 AI 指令流月/流日/流时导出
        </Typography>
      </DialogTitle>

      <DialogContent>
        <Stack spacing={2}>
          {/* 套餐展示 */}
          <Stack spacing={1.5}>
            {PLANS.map((plan) => (
              <Box
                key={plan.key}
                sx={{
                  p: 1.5,
                  borderRadius: 2,
                  border: (theme) =>
                    plan.highlight
                      ? `2px solid ${theme.palette.primary.main}`
                      : `1px solid ${theme.palette.divider}`,
                  bgcolor: plan.highlight ? "primary.50" : "background.paper",
                  position: "relative",
                }}
              >
                {plan.highlight && (
                  <Chip
                    label="推荐"
                    color="primary"
                    size="small"
                    sx={{
                      position: "absolute",
                      top: -10,
                      right: 8,
                      height: 20,
                      fontSize: 12,
                    }}
                  />
                )}
                <Stack direction="row" alignItems="center" justifyContent="space-between">
                  <Box>
                    <Typography variant="subtitle2">{plan.label}</Typography>
                    <Typography variant="caption" color="text.secondary">
                      {plan.desc}
                    </Typography>
                  </Box>
                  <Stack direction="row" alignItems="baseline" spacing={0.3}>
                    <Typography variant="h6" color="primary" fontWeight="bold">
                      {plan.price}
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                      {plan.unit}
                    </Typography>
                  </Stack>
                </Stack>
              </Box>
            ))}
          </Stack>

          <Divider>
            <Typography variant="caption" color="text.secondary">
              已有激活码？下方兑换
            </Typography>
          </Divider>

          {/* 激活码兑换 */}
          <Stack spacing={1.5}>
            {error && <Alert severity="error">{error}</Alert>}
            {success && <Alert severity="success">{success}</Alert>}
            <TextField
              label="激活码"
              placeholder="请输入激活码"
              variant="outlined"
              fullWidth
              value={code}
              onChange={(e) => setCode(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") handleRedeem();
              }}
              disabled={loading}
            />
            {/* 购买联系方式已移除（仅保留QQ群和邮箱），原代码保留：
            <Typography variant="caption" color="text.secondary" sx={{ textAlign: "center" }}>
              购买请联系，点击复制号码
            </Typography>
            <Stack direction="row" spacing={1} justifyContent="center" alignItems="center">
              <Chip
                icon={<ContentCopyIcon fontSize="small" />}
                label="QQ：252468400"
                size="small"
                variant="outlined"
                onClick={() => {
                  navigator.clipboard.writeText("252468400").catch(() => {});
                }}
                sx={{ cursor: "pointer" }}
              />
              <Chip
                icon={<ContentCopyIcon fontSize="small" />}
                label="微信：ahaofan_cn"
                size="small"
                variant="outlined"
                onClick={() => {
                  navigator.clipboard.writeText("ahaofan_cn").catch(() => {});
                }}
                sx={{ cursor: "pointer" }}
              />
            </Stack>
            */}
          </Stack>
        </Stack>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={handleClose} color="inherit">
          取消
        </Button>
        <Button
          onClick={handleRedeem}
          variant="contained"
          disabled={loading || !code.trim()}
        >
          {loading ? "兑换中..." : "立即兑换"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
